<script>
	export let iconClass = '';
</script>

<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class={iconClass}>
	<rect x="0.5" y="0.5" width="23" height="23" rx="11.5" fill="#FBC435"/>
	<rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="#FBC435"/>
	<path d="M9 7.5L16 12L9 16.5V7.5Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
